<template>
  <div>
    <div class="page-body">
      <maintenance-table :data="filterData"></maintenance-table>
    </div>
  </div>
</template>

<script>
import { BIKE_STATUS } from '@/libs/enum'
import { MAINTENANCE_DATA } from '@/libs/fakeData'
import MaintenanceTable from '@/components/Tables/Maintenance'

export default {
  components: { MaintenanceTable },
  data () {
    return {
      data: MAINTENANCE_DATA
    }
  },
  computed: {
    filterData () {
      return this.data.filter(record => BIKE_STATUS[record.status] === 'waiting')
    }
  }
}
</script>
